import { forwardRef, ReactElement } from "react";

import { Grid } from "@mui/material";
import { FormInput } from "@4uhub/lib4uhub";
import { applyTranslations } from "./typebot.utils";
import { useTranslation } from "react-i18next";

export interface IFieldsProps {}

export interface IFieldsRef {
  setVerifyToken: (token: string) => void;
}

const Fields = forwardRef<IFieldsRef, IFieldsProps>((): ReactElement => {
  const { t } = useTranslation();

  return (
    <>
      <Grid container spacing={2}>
        <FormInput
          name="typebotViewerHost"
          label={t(applyTranslations("typebot_viewer_host"))}
          size="small"
          fullWidth
        />
      </Grid>
    </>
  );
});

export default Fields;
